export default "__VITE_ASSET__CQ9abxJH__"